import { Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import TextLogo from '../../../Components/TextLogo';
import { AppColors } from '../../../Utils/helper/AppColors';
import ReviewCards from './ReviewCards';
import useResponsive from '../../../Utils/hooks/useResponsive';

export default function LoginLayout({ children, heading, subHeading , textLogo }) {
	const { small } = useResponsive();
	return (
		<Grid position="relative"
		sx={{
			background: 'linear-gradient(to bottom, #E9EAF7,#F6F6FB)', // Added gradient background
		}}
		>
			{/* <TextLogo m={5} align="center" position="absolute" /> */}
			<Grid container p={2} direction="row" height="100vh">
				<Grid item xs={small ? 12 : 6} height="100%" alignItems="center" justifyContent="center" display="flex">

					<Stack width={small ? '86%' : '74%'} maxWidth={650}>

					    <TextLogo mb={{ xs: 6 , sm : 8 , md: 12}} size={48} textLogo={textLogo}/>

						<Stack gap={0}>
							<Typography fontSize={35} fontWeight={700} color={AppColors.TEXT_PRIMARY}>
								{heading}
							</Typography>
							<Typography fontSize={14} fontWeight={500} color={AppColors.TEXT_TERTIARY}>
								{subHeading}
							</Typography>
						</Stack>

						<Stack mt={3} mb={10} gap={2}>
							{children}
						</Stack>
					</Stack>
				</Grid>
				{!small && (
					<Grid height="100%" item xs={6}>
						<ReviewCards />
					</Grid>
				)}
			</Grid>
		</Grid>
	);
}

